import { useRouter } from 'next/router'
import AuthLayout from 'components/login/auth-layout'
// import RegisterForm from 'components/login/register-form'
import CompleteAccount from 'components/login/complete-account'
import AuthRedirect from 'components/login/auth-redirect'

function Register() {
  const { query: { completeAccount, is_free } } = useRouter()
  const googleSucces = () => {
    const fbAds = sessionStorage.getItem('fbAds')
    if (fbAds === 'true' && window.fbq) {
      window.fbq('trackCustom', 'NewUser')
      sessionStorage.removeItem('fbAds')
    }
  }
  return (
    <AuthLayout
      title={is_free ? 'El curso es gratis solo debes crear una cuenta para guardar tu avance' : 'Crea una cuenta en LeonidasEsteban.com, es gratis'}
      googleCta="Regístrate con Google"
      githubCta="Regístrate con GitHub"
      query="¿Ya tienes una cuenta?"
      link="/login"
      linkCta="Inicia sesión"
      authDisabled={completeAccount}
      googleSucces={googleSucces}
    >
      {completeAccount && <CompleteAccount />}
    </AuthLayout>
  )
}

Register.pageTheme = {
  background: 'var(--sky)',
}

export const getServerSideProps = AuthRedirect

export default Register
